<template>
  <div class="page-teacher">
    <template v-if="Array.isArray(teacherList)">
      <div class="teacher-box" v-for="(item, index) in teacherList" :key="index" @click="goPage(item)">
        <div class="teacher-left">
          <img class="teacher-img" v-if="item.photo" :src="item.photo" alt="" />
          <img class="teacher-img" v-else src="../../../images/new-logo.png" alt="" />
        </div>
        <div>
          <div class="name">{{ item.name }}</div>
          <div>{{ item.desc }}</div>
        </div>
      </div>
    </template>
    <div v-else class="teacher-box">
      <div class="teacher-left">
        <img class="teacher-img" v-if="teacherList.photo" :src="teacherList.photo" alt="" />
        <img class="teacher-img" v-else src="../../../images/new-logo.png" alt="" />
      </div>
      <div class="name">{{ teacherList.name }}</div>
      <div>
        <span class="categorie-name" v-for="(item, index) in teacherList.categories" :key="index">{{ item.name }}
          <span v-if="index != (teacherList.categories.length-1)">、</span>
        </span>
      </div>
      <div class="desc">{{ teacherList.desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    teacherList: {
      type: [ Array, Object ],
      default: () => ({}),
    },
  },

  methods: {
    goPage(item) {
      this.$emit('page', item);
    },
  },
};
</script>

<style scoped>
.page-teacher {
  margin: 0 40px;
}

.teacher-box {
  margin: 0 0 26px;
  padding: 20px 20px 38px;
  min-height: 280px;
  background: #fff;
  border-radius: 12px;
}

.teacher-left {
  float: left;
  padding: 0 30px 30px 0;
  height: 240px;
  width: 240px;
}

.teacher-img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.name {
  padding: 22px 0 34px 0;
  font-size: 36px;
  font-weight: 600;
}

.categorie-name {
  padding-right: 4px;
}

.desc {
  margin-top: 20px;
}
</style>
